module.exports = __webpack_public_path__ + "img/culture_05.00857cec.png";